module.exports = __webpack_public_path__ + "static/media/FordDirect_Logo_Approved.5aa2de6b.svg";